export default __webpack_public_path__ + "static/media/goodweT.28951e22.jpg";